import { STAGE, type Stage } from "../../convex/constants/stage";

export function getDealExceptionLabel(
  stage: Stage,
  exceptionKind?: "rejected" | "no_response",
): string {
  if (exceptionKind === "rejected") return "Offer was declined.";
  if (exceptionKind === "no_response") return "Offer received no response.";
  switch (stage) {
    case STAGE.EXPIRED:
      return "Offer expired before either side acted.";
    case STAGE.CANCELLED:
      return "Deal was cancelled.";
    case STAGE.REFUNDED:
      return "Order was refunded.";
    case "awaiting_review":
    case "awaiting_scheduling":
    case "complete":
    case "confirmed_awaiting_payment":
    case "confirming_pickup":
    case "delivered":
    case "draft":
    case "in_transit":
    case "scheduled":
    case "submitted":
    case "vendor_responding":
      return "This deal has stopped progressing.";
    default: {
      const unhandled: never = stage;
      void unhandled;
      return "This deal has stopped progressing.";
    }
  }
}
